"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defaultOptions = _interopRequireDefault(require("./default-options"));

exports.onRouteUpdate = function (_ref, pluginOptions) {
  var location = _ref.location;
  var options = (0, _extends2.default)({}, _defaultOptions.default, pluginOptions);

  if (options.productionOnly && process.env.NODE_ENV !== 'production' || !Array.isArray(window._hsq)) {
    return null;
  }

  var trackPageView = function trackPageView() {
    var path = location ? "" + location.pathname + location.search + location.hash : undefined;

    window._hsq.push(['setPath', path]);

    window._hsq.push(['trackPageView']);
  }; // wrap inside a timeout to make sure react-helmet is done with it's changes (https://github.com/gatsbyjs/gatsby/issues/9139)
  // react-helmet is using requestAnimationFrame (https://github.com/nfl/react-helmet/blob/5.2.0/src/HelmetUtils.js#L296-L299)


  if (typeof window.requestAnimationFrame === 'function') {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(trackPageView);
    });
  } else {
    // simulate 2 requestAnimationFrame calls
    setTimeout(trackPageView, 32);
  }

  return null;
};